<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          btnTitle="Add New"
          :showBtn="false"
          :showSettingBtn="false"
          :showAddNew="true"
          title="Department List"
          @onClickAddNewButton="onClickAddNewButton"
          @onClickSettingButton="onClickSettingButton"
      />
      <div class="row">
        <div class="col-10">
          <label for="colFormLabel" class="col-form-label">Search</label>
          <input class="form-control" type="text" name="status" v-model="quick_search">
        </div>
        <div class="col-2">
          <label for="">&nbsp;</label>
          <button
              style="min-width: 64px;margin-top: 1rem;"
              @click="onClickSearchButton"
              class="btn btn-primary waves-effect waves-float waves-light form-control"
          >Go
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 mt-2">
      <div class="d-flex justify-content-end px-2">
        <button
            @click="exportTable"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
        >
          Export
        </button>
      </div>
    </div>
    <ListTable
        :departments="departmentList"
        @onEdit="onEditDepartment"
    />
    <div class="mb-2"></div>
    <div class="px-2 position-absolute bottom-0">
      <Pagination
          :offset="offset"
          @onPageChange="onPageChange"
          ref="pagination"
      />
    </div>

    <DepartmentAddModal
        :modalTitle="department.id ? 'Edit Department' : 'Add Department'"
        :showParent="true"
        ref="department"
        :formData="department"
        @onSubmitForm="handleDepartmentSubmit"
        @onCloseDepartmentModal="resetForm"
    />
  </div>
</template>

<script>
import TitleButton from '@/components/atom/TitleButton'
import ListTable
  from '@/components/molecule/procurement/organization-settings/admin-setup/department/DepartmentListingTable.vue'
import DepartmentAddModal
  from '@/components/molecule/procurement/organization-settings/admin-setup/department/DepartmentAddModal.vue'
import Pagination from '@/components/atom/Pagination'
import Loader from '@/components/atom/LoaderComponent'
import {inject} from "vue";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";

export default {
  name: 'DepartmentList',

  components: {
    TitleButton,
    ListTable,
    DepartmentAddModal,
    Pagination,
    Loader,
  },

  data: () => ({
    loading: false,
    quick_search: null,
    offset: 20,
    departmentList: [],
    department: {
      name: null,
      short_name: null,
      code: null,
      email: null,
      contact_no: null,
      address: null,
    },
  }),

  computed: {
    companyId() {
      return this.$route.params.companyId
    },
  },

  methods: {
    onClickAddNewButton() {
      this.$refs.department.toggleModal()
    },

    onClickSettingButton() {
      alert('Setting Button clicked');
    },

    onClickSearchButton() {
      alert('Search Button clicked');
    },

    resetForm() {
      this.department = {
        name: null,
        short_name: null,
        code: null,
        email: null,
        contact_no: null,
        address: null,
      }
    },

    async handleDepartmentSubmit() {
      this.loading = true

      this.department.company_id = this.$route.params.companyId;
      this.department.user_id = this.$store.getters["user/getUser"].id;
      this.department.updated_by = this.$store.getters["user/getUser"].id;

      try {
        let res = null;

        if (this.department.id) {
          res = await this.updateDepartment(this.department.id, this.department);
        } else {
          res = await this.createNewDepartment(this.department);
        }

        if (!res.status) {
          this.showError(res.message);
        } else {
          this.showSuccess(res.message);
          this.resetForm();
          this.onClickAddNewButton();
          await this.getDepartments();
        }
      } catch (err) {
        if (!err.response) {
          this.showError('Something is wrong. Check your connectivity!!')
        } else if (err.response) {
          this.showError(err.response.message)
        }
      } finally {
        this.loading = false;
      }
    },

    async getDepartments() {
      const query = this.getQuery();
      try {
        this.loading = true;
        let res = await this.fetchDepartmentList(query);
        if (!res.status) {
          this.resetPagination();
        } else if (res.status) {
          this.departmentList = res.data;
        }
      } catch (err) {
        if (err.response) {
          this.showError(err.response.message)
        }
      } finally {
        this.loading = false
      }
    },

    getQuery() {
      let query = '?company_id=' + this.companyId;
      query += '&offset=' + this.offset;
      if (this.page) query += '&page=' + this.page;
      return query;
    },

    onPageChange(page) {
      let routeQuery = Object.assign({}, this.$route.query)
      routeQuery.page = page
      this.$router.push({path: this.$route.path, query: routeQuery})
      setTimeout(() => {
        this.getDepartments();
      }, 100)
    },

    onEditDepartment(data) {
      this.department = data;
      this.onClickAddNewButton();
    },

    exportTable() {
      //todo
    },
  },

  setup() {
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');

    const {
      loading,
      fetchDepartmentList,
      createNewDepartment,
      updateDepartment,
    } = handleDepartments()

    return {
      loading,
      showError,
      showSuccess,
      fetchDepartmentList,
      createNewDepartment,
      updateDepartment,
    }
  },

  mounted() {
    this.getDepartments();
  }
}
</script>
